<template>
  <div class="dating">
    <img src="./gentleman.jpg" alt />
    <div class="title">要約會了嗎？給你一份紳士該注意的清單</div>
    <div class="pre">
      嗨，你好我們是 Let’s Movie 的創辦團隊
      <br />很高興你點開來看了
    </div>
    <p>
      在經過配對成功<br />
      喬好時間地點之後<br />
      我相信你已經準備要約會了
    </p>

    <p>
      我們想跟你做個溫馨提醒<br />
      目的就是希望能確保你在約會當天<br />
      你呈現出來的狀態是輕鬆自在的<br />
      營造的感覺讓彼此都是開心舒服的
    </p>
    <p>
      第一點<br />
      關於穿著打扮<br />
      第一眼的好印象很重要<br />
      這應該是老生常談了<br />
      很多人都說<br />
      約會的穿著不要太正式<br />
      也不要太隨便<br />
      這樣有點難抓出一個適合的標準<br />
      這裡提供幾個範例<br />
      讓你可以照著簡單乾淨這個大方向走
    </p>
    <p>1. 西裝外套 + T-shirt 組合</p>

    <img src="./gentle1.png" alt class="content" />
    <img src="./gentle2.png" alt class="content" />

    <p>
      這個組合是帶有正式跟休閒的 Smart Casual 風格<br />
      只是要注意，鞋子一定要是乾淨的，尤其是白色款的鞋
    </p>

    <p>2. 素色的休閒襯衫 + T-shirt + 牛仔褲</p>
    <img src="./gentle3.png" alt class="content" />

    <p>
      這個組合適合習慣穿牛仔褲出門的你<br />
      只是要注意，牛仔褲要合身，長度不能過長<br />
      會看起來沒精神
    </p>

    <p>3. 單色毛衣 + 白襯衫內搭 + 色褲</p>
    <img src="./gentle4.png" alt class="content" />

    <p>
      穿毛衣的男生給人成熟穩重的感覺<br />
      如果再戴一個質感好的手錶，會更加分
    </p>

    <p>
      其他如頭髮的打理，香水的選擇<br />
      只要有好好處理，都會給人留下<br />
      有質感的好印象
    </p>

    <p>
      第二點<br />
      關於電影開場前<br />
      這段時間大概會從<br />
      相認碰面開始到電影開始前結束<br />
      這段時間不建議聊太深入的話題<br />
      因為有很多事情要做<br />
      會稍微手忙腳亂<br />
      比起了解對方<br />
      這個階段關心她的狀態顯得相對重要<br />
      詢問是否要買什麼點心，飲料帶進場<br />
      對方趕過來這裏的方式<br />
      今天的精神狀態等<br />
      呈現出今天你是主人，對方來作客的大方態度<br />
      如果還有時間，可以從聊不具隱私性的問題開始<br />
      工作，喜歡的電影類型，怎麼會使用Let’s Movie 電影約會的服務等
    </p>

    <p>
      第三點<br />
      關於電影放映中<br />
      從電影開始之後到電影放映結束<br />
      這段過程並不會有談話<br />
      但這個時候的呈現<br />
      也同時代表我們是否能作為一個好聽眾<br />
      不爆雷，不破壞對方體驗<br />
      如果你們彼此對電影中的某一個橋段有共鳴<br />
      而相視而笑<br />
      這個時候不說什麼所傳達的比說了還要多得多
    </p>

    <p>
      第四點<br />
      關於電影結束之後<br />
      跟電影開演前不同的是<br />
      你們已經共同經歷了一場冒險<br />
      有了共同的話題<br />
      可以從喜歡剛剛電影中的哪一個橋段開始延伸<br />
      對方會展示其中的心路歷程<br />
      而你可以從其心路歷程連結到自己的體驗<br />
      這樣話題就容易展開了<br />
      之後如果聊的很融洽<br />
      也可以就近找個地方坐下來聊天，延續熱度<br />
      當然這過程中的一切都要尊重對方的意願<br />
      因為在這些談話當中，很多內容其實最後都不重要<br />
      而是你傳遞給對方的感覺，今天的整個過程<br />
      是否是愉快而舒服的，讓女生覺得有安全感的<br />
      如果對方願意，可以互相留下聯絡方式<br />
      確認對方到家報平安<br />
      讓對方留了一個完整的好印象<br />
      那麼之後要再約出來也會簡單許多<br />
      也請記得，如果對方表現的不錯<br />
      約會完之後在bot 上給對方一個好評喔
    </p>

    <div class="end">Let’s Movie 電影約會團隊 祝你約會順利</div>
  </div>
</template>
<style lang="scss" scoped>
.dating {
  width: 1280px;
  margin: 0px auto;
  text-align: justify;

  img {
    width: 100%;
  }

  .content {
    width: 52%;
    margin: 0 auto;
    display: block;
  }

  .title {
    font-size: 36px;
    color: #333;
    margin-bottom: 30px;
  }

  .pre {
    margin-bottom: 30px;
  }

  p {
    line-height: 2.5;
    margin-bottom: 15px;
  }

  .talk {
    color: #000;
    font-weight: bold;
    font-size: 17px;
    margin-left: -0.5rem;
  }

  .end {
    font-size: 20px;
    color: #990000;
    margin-top: 30px;
  }
}

/* 螢幕尺寸標準 */
/* 平板尺寸 */
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
}

/* 手機尺寸 */
@media only screen and (max-width: 767px) {
  .dating {
    width: 100vw;
    padding: 0 5vw;
    margin-top: 0px;

    img {
      width: 100vw;
      margin-left: -5vw;
    }

    .title {
      font-size: 24px;
      font-weight: bold;
    }

    .pre {
    }

    p {
      font-size: 14px;
      line-height: 30px;
    }

    .talk {
      font-size: 15px;
    }

    .end {
      font-size: 16px;
      margin-bottom: 30px;
    }
  }
}

// 避免內容電腦過渡平板時，設計未考量的調整
@media only screen and (min-width: 1025px) and (max-width: 1199.98px) {
}

// 避免過度到 1280 x 720 時，設計未考量的調整
@media only screen and (min-width: 1025px) and (max-width: 1280px) {
}
</style>

<script>
// @ is an alias to /src
// import Loading from '@/components/Loading.vue'
// import { setTimeout } from 'timers'

export default {
  name: 'dating',
  components: {
    // Loading,
  },

  data() {
    return {}
  },

  methods: {},

  created() {},
}
</script>
